module.exports = __webpack_public_path__ + "img/shake_icon.9e1d922b.png";